function Particle() {
  return null;
}

export default Particle;
